var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7815 1.76387C5.92659 1.74538 6.07341 1.74538 6.2185 1.76387C6.44958 1.79332 6.7076 1.904 7.10929 2.22659C7.52282 2.55869 8.01086 3.0495 8.72 3.76499L10.4673 5.52796C10.7589 5.82216 11.2338 5.82427 11.528 5.53269C11.8222 5.24111 11.8243 4.76624 11.5327 4.47204L9.7539 2.6773C9.08396 2.00133 8.53641 1.44886 8.04854 1.05706C7.54122 0.649628 7.02628 0.354695 6.40816 0.275909C6.13714 0.241364 5.86286 0.241364 5.59184 0.275909C4.97372 0.354695 4.45878 0.649628 3.95146 1.05706C3.46358 1.44886 2.91604 2.00134 2.24609 2.67732L0.467309 4.47204C0.175726 4.76624 0.177844 5.24111 0.472041 5.53269C0.766238 5.82427 1.24111 5.82216 1.53269 5.52796L3.28 3.76499C3.98914 3.0495 4.47718 2.55869 4.89071 2.22659C5.2924 1.904 5.55042 1.79332 5.7815 1.76387Z",
    fill: "#2D264B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/UpArrowIcon.e1f6c30a78b98bef3a10d44841a6fa30.svg";
export { ForwardRef as ReactComponent };